<template>
  <div class="fxgkBox">
    <!-- <div class="kpbanner">
        <div class="kpbCon">
          <div class="conleft">
            <div class="leftTitle">科普解读</div>
            <div class = 'leftCon'>什么是农产品安全，农产品质量优势如何保障？扁豆在烹饪时要注意哪些？玉米发霉如何食用？韭菜和菠菜的相互作用是什么？</div>
            <div class="leftBtn">更多科普知识</div>
          </div>
          <div class="conRight"></div>
        </div>
      </div> -->

    <div class="kpListBox">
      <div class="listTitle">{{fxglData.columnTitle}}</div>
      <div class="seeMoreBox">
        <div class="seeMore" @click="seeMoreFx()">
          <p>{{fxglData.columnDesc}}</p>
          <img
            style="width: 10px; height: 10px; margin-left: 5px"
            src="../../../../static/images/kpMore.svg"
            alt=""
          />
        </div>
      </div>

      <!-- <div class="navListBox">
            <div :class= "flag == index? 'isnavItemTitle' : 'navItemTitle'  " v-for = '(item,index) in list' :key = 'index' @click = 'handleClickNav(index)'>{{ item.value }}</div>
          </div> -->

      <div class="fxgkListBox">
        <div class="fpListLeft">
          <div class="listItem" v-for="(treeLi,treeIndex) in treeList" :key="treeLi.id" @click="selectHy(treeLi.id,treeLi.catgName)" @mouseover="selectHy(treeLi.id,treeLi.catgName)">
            <div class="xunhuan">
              <div class="itemRight" :class="treeLi.id == selectIndex?'active':''">
                <div class="itemwrite">{{treeLi.catgName}}<i class="el-icon-arrow-right"></i></div>
              </div>
            </div>
          </div>
        </div>
        <div class="showBox">
          <!-- <div class="fxTitle">{{hyTitle}}风险管控信息</div> -->
          <div class="showList state" v-for="(fxglLi,fxglIndex) in fxglList.slice(0,3)" :key="fxglLi.id" @click="seeDetails(fxglLi.riskFillId)">
            <div class="showleft">
                  <img v-if="fxglLi.imageMageGetVos.length>0" :src="commonUrl+fxglLi.imageMageGetVos[0].url" alt="">
                  <img v-else src="../../../../static/images/default_img.png" alt="">
            </div>
            <div class="showRight">
              <div class="srTitle srstate node_name">
                {{fxglLi.catgName}}
              </div>
              <div class="srCont">
                <div class="flex_div node_name" v-if="fxglLi.atrCatgNames">
                  <span class="blod_font ">分类：</span>
                  {{fxglLi.atrCatgNames}}
                </div>
                <!-- <div class="flex_div node_name" v-if="fxglLi.alias">
                  <span class="blod_font ">别名：</span>
                  {{fxglLi.alias}}
                </div> -->
                <!-- <div>主要生产区域：{{fxglLi.prodArea}}</div> -->
                <div class="flex_div" v-if="fxglLi.risk">
                  <div class="w105" ><span class="blod_font w100">主要病虫草害：</span></div>
                  <div  class="node_name width_640" :title="fxglLi.rhmNames">
                    {{fxglLi.rhmNames}}
                  </div>
                </div>
                <div class="flex_div" v-if="fxglLi.risk">
                  <div class="w105" ><span class="blod_font">主要风险隐患：</span></div>
                  <div class="node_name width_640" :title="fxglLi.risk">
                    {{fxglLi.risk}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 循环结束 -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {},
  data() {
    return {
      commonUrl,
      hyTitle:'',
      flag: "0",
      selectIndex:'0',
      initData:{
        "dispFlag": "",
        "pageInfo": {
          "pageNo": 0,
          "pageSize": 0
        },
        "productClassId": 0,
        "searchKey": ""
      },
      treeList:[],
      fxglList:[],
      fxglData:{}
    };
  },
  mounted(){
    this.getTree()
    this.getFxData()
  },
  methods: {
    //查询更多风险管控
    seeMoreFx(){
      this.$router.push("riskControl")
    },
    seeDetails(id){
        // this.$router.push({path:"riskManagementDetails",query:{id:id}})
        window.open('riskManagementDetails?id='+id,'_blank');
    },
    //获取分类
    getTree(){
      this.Axios({
          url: Action.FINDCLASSMAGETREE,
          method: "post",
          data: {
            "flag": "0",
            "searchKey": ""
          }
      }).then( (res) => {
          var data = res.data;
          if(data.code=='000') {
            this.treeList = data.result[0].children
            this.selectIndex = this.treeList[0].id
            this.hyTitle = this.treeList[0].catgName
            this.getFxLiST()
          } 
          
      }).catch(function (response) {
          console.log(response);
      });
    },
    //获取风险管控列表
    getFxLiST(){
      this.Axios({
          url: Action.FINDPORTALFILLLIST,
          method: "post",
          data: {
            "enableFlag": "",
            "flag": "1",
            "pClassId": this.selectIndex
          }
      }).then( (res) => {
          var data = res.data;
          if(data.code=='000') {
            let list = []
            data.result.forEach(e=>{
              if(e.enableFlag=='0'){
                list.push(e)
                }
            })
            this.fxglList = list;
          } 
          
      }).catch(function (response) {
          console.log(response);
      });
    },
    //获取风险管控模块信息
    getFxData(){
      this.Axios({
          url: Action.GETFLOORINDEXSHOWOTHER,
          method: "post",
          data: {
            "sort": 10
          }
      }).then( (res) => {
          var data = res.data;
          if(data.code=='000') {
              this.fxglData = data.result
          } 
          
      }).catch(function (response) {
          console.log(response);
      });
    },
    //选择分类查询风险
    selectHy(index,name){
        this.selectIndex = index;
        this.hyTitle = name;
        // 接口请求
        this.getFxLiST()
    },
  },
};
</script>

<style lang="less" scoped>
.fxgkBox {
  width: 100%;
  // background:pink;
  .kpbanner {
    height: 234px;
    background: #2c6eff;
    .kpbCon {
      width: 1180px;
      height: 234px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      .conleft {
        width: 795px;
        height: 234px;
        .leftTitle {
          width: 300px;
          height: 50px;
          font-size: 36px;
          color: #ffffff;
          margin: 43px 0 5px;
        }
        .leftCon {
          width: 795px;
          height: 56px;
          line-height: 28px;
          font-size: 20px;
          color: #ffffff;
        }
        .leftBtn {
          width: 104px;
          height: 34px;
          text-align: center;
          line-height: 34px;
          background-color: #ff964a;
          font-size: 14px;
          color: #ffffff;
          margin-top: 20px;
          cursor: pointer;
        }
      }
      .conRight {
        width: 339px;
        height: 234px;
        background-color: #1b52ca;
      }
    }
  }
  .fxgkListBox {
    width: 1180px;
    height: 548px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    -webkit-box-shadow: 0px 2px 8px 0px #bcbcbc;
    box-shadow: 0px 2px 8px 0px #bcbcbc;
    border-radius: 4px;
  }
  .kpListBox {
    width: 1180px;
    margin: 0 auto;
    padding-top: 30px;
    height: 700px;
    .fpListLeft {
      width: 240px;
      // height: 488px;
    //   box-shadow: 0px 2px 8px 0px #efefef;
      border-radius: 4px;
      background: url("../../../../static/images/fxgk.png") no-repeat 100%;
      background-size: 100% 100%;
      .listItem {
        width: 240px;
        height: 48px;
        // padding-left: 38px;
        cursor: pointer;
        .xunhuan {
          display: flex;
          .itemLeft {
            width: 88px;
            height: 89px;
            background-color: #d8d8d8;
            border-radius: 5px;
          }
          .itemRight {
            flex: 1;
            color: #222222;
            border-left: 4px solid transparent;
            // margin-left: 12px;
            .rightTitle {
              width: 100%;
              display: flex;
              justify-content: space-between;
              align-items: center;
              .titleCon {
                width: 240px;
                height: 48px;
                font-size: 16px;
                font-weight: 900;
                color: #222222;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .yjImg {
                width: 14px;
                height: 14px;
              }
            }
            .itemwrite {
              width: 145px;
              font-family: PingFangSC-Regular;
              font-size: 16px;
              font-weight: normal;
              font-stretch: normal;
              height: 48px;
              line-height: 48px;
              letter-spacing: 0px;
              // color: #818d99;
              padding-left: 30px;
            }
            .liulan {
              width: 77px;
              height: 20px;
              font-family: PingFangSC-Regular;
              font-size: 12px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 20px;
              letter-spacing: 0px;
              color: #ff964a;
              margin-top: 6px;
            }
          }
            .active{
                border-left: 4px solid #fa6400;
                color: #fa6400;
                background: #fff;
            }
            i{
              margin-left: 10px;
            }
        }
      }
    //   .listItem:hover {
    //     background-color: #ffffff;
    //     box-shadow: 0px 0px 8px 0px #89aeff;
    //     border-radius: 4px;
    //   }
      .xunhuan:hover .itemRight .rightTitle .titleCon {
        color: #2c6eff;
      }
    }
    .listTitle {
      margin: 0 auto 5px;
      height: 40px;
      font-family: PingFangSC-Semibold;
      font-size: 28px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 40px;
      letter-spacing: 0px;
      color: #222222;
      font-weight: 900;
      text-align: center;
    }
    .seeMoreBox {
      margin: 0 auto 30px;
      display: flex;
      justify-content: space-around;
    }
    .seeMore {
      font-size: 14px;
      color: #ff964a;
      display: flex;
      align-items: center;
      cursor: pointer;
    }
    .navListBox {
      width: 940px;
      height: 66px;
      margin: 0 auto;
      border-bottom: solid 1px #dbdbdb;
      display: flex;
      justify-content: space-between;
      padding: 0 50px;
      box-sizing: border-box;
      margin-bottom: 30px;
      .navItemTitle {
        height: 66px;
        font-size: 16px;
        color: #222222;
        display: flex;
        align-items: center;
        cursor: pointer;
      }
      .isnavItemTitle {
        height: 66px;
        font-size: 16px;
        color: #2c6eff;
        display: flex;
        align-items: center;
        border-bottom: 3px solid #2c6eff;
        cursor: pointer;
      }
    }
    .showBox {
      height: 318px;
      width: 940px;
      margin: 0 auto;
      // display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .fxTitle{
        width: 300px;
        height: 28px;
        font-family: PingFangSC-Medium;
        font-size: 20px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #222222;
        font-weight: 900;
        margin: 20px 0 0 30px;
      }
      .state {
        background-color: #ffffff;
        // box-shadow: 0px 2px 8px 0px #efefef;
        border-radius: 4px;
      }
      .showList {
        width: 880px;
        // height: 182px;
        padding: 20px 0;
        margin: 0 30px;
        box-sizing: border-box;
        display: flex;
        cursor: pointer;
        border-bottom: solid 1px #ebebeb;
        .showleft {
          width: 120px;
          height: 120px;
          background-color: #d8d8d8;
          border-radius: 4px;
        }
        .showRight {
          flex: 1;
          // height: 120px;
          margin-left: 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .srTitle {
            width: 740px;
            line-height: 28px;
            height: 28px;
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #222222;
            font-family: PingFangSC-Semibold;
            color: #222222;
            font-weight: 900;

            .line {
              height: 20px;
              width: 2px;
              background: #222222;
              margin: 0 10px;
            }
          }
          .srstate {
            // background: url("../../../../static/images/rightjt.svg") no-repeat 100%;
          }
          .srCont {
            width: 740px;
            // height: 72px;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 24px;
            letter-spacing: 0px;
            color: #818d99;
            margin-top: 15px;
            .srName{
              width: 740px;
              display:inline-block;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .srData {
            height: 17px;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #818d99;
          }
        }
      }
      .showList :last-child{
        border: none;
      }
    //   .showList:hover {
    //     background-color: #ffffff;
    //     box-shadow: 0px 2px 8px 0px #bcbcbc;
    //   }

    //   .showList:hover .srstate {
    //     color: #ff964a;
    //     // background:url('../../../../static/images/banner.png')  no-repeat   100%;
    //   }
    //   .showList:hover .srTitle .line {
    //     background: #ff964a;
    //   }
    }
  }
}
.width_640{
  width: 640px;
}
.flex_div{
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  // justify-content: space-between;
}
.blod_font{
  font-size: 14px;
	font-weight: 600;
	color: #3d4751;
}
.w105{
  width: 105px;
}
</style>



// WEBPACK FOOTER //
// src/views/homePage/compontents/fxgk.vue